import { useMsal } from "@azure/msal-react";

const LEASE_ADMIN_ROLE = ["leaseadmin"]; // leaseadmin;

export const useIsLeaseAdmin = (): boolean => {
  const { instance } = useMsal();
  const currentUser = instance.getActiveAccount();
  return (
    currentUser?.idTokenClaims?.roles?.some((item) =>
      LEASE_ADMIN_ROLE.includes(item)
    ) ?? false
  );
};
